<template>
  <div class="add-step" style="overflow: scroll">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>اطلاعات حساب</h2>
        <p>مرحله بعد:اطلاعات کسب و کار</p>
      </div>
      <div>
        <svg class="header-progresbar2">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-1" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">1</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">3</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p>لطفا موارد زیر را با دقت پر کنید</p>
      <div class="gruop">
        <p>نام حساب</p>
        <input v-model="name" class="inputName" placeholder="نام حساب" />
        <p class="error" v-if="err && name != null">
          پر کردن این فیلد الزامی است.
        </p>
      </div>
      <div class="gruop">
        <p>لطفا یک آیدی برای خود انتخاب کنید</p>
        <input v-model="business_id" class="inputName" placeholder="نام حساب" />
        <p class="error" v-if="err && name != null">
          پر کردن این فیلد الزامی است.
        </p>
      </div>
      <div class="gruop">
        <p>حساب بانکی</p>
        <select v-model="account" class="inputName account-type">
          <option
            v-for="Account in accounts"
            :key="Account.id"
            :value="Account.id"
          >
            {{ Account.name }}
          </option>
        </select>
        <p v-if="err && name != null" class="error">
          پر کردن این فیلد الزامی است.
        </p>
      </div>
      <div class="gruop">
        <p>نوع حساب</p>
        <select v-model="accountCategory" class="inputName account-type">
          <option
            v-for="(AccountCategory, i) in accountCategorys"
            :key="i"
            :value="AccountCategory.id"
          >
            {{ AccountCategory.title }}
          </option>
        </select>
        <p v-if="err && name != null" class="error">
          پر کردن این فیلد الزامی است.
        </p>
      </div>
      <button class="m-btn add-confer-btn" @click="addCardHandeler">
        تایید
      </button>
    </div>
  </div>
</template>

<script>
import { maska } from "maska";
export default {
  directives: { maska },
  mounted() {
    this.getAccountCategory();
  },
  data() {
    return {
      err: false,
      loading: false,
      acountCategorys: null,
      business_id: null,
      accounts: null,
      account: null,
      accountCategory: null,
      name: null,
    };
  },
  methods: {
    goBackHandler() {
      this.$router.back();
    },
    getAccountCategory() {
      this.loading = true;
      this.$store
        .dispatch("businessaccount/getAccountCategoryList")
        .then((rsp) => {
          this.accountCategorys = rsp;
          this.getAccounts();
        });
    },
    getAccounts() {
      this.$store
        .dispatch("accounts/getList")
        .then((rsp) => {
          this.accounts = rsp;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addCardHandeler() {
      this.err = false;
      if (
        this.account == null ||
        this.accountCategory == null ||
        this.name == null ||
        this.business_id == null
      ) {
        this.err = true;
      } else {
        this.$store.commit("businessaccount/setName", this.name);
        this.$store.commit("businessaccount/setAccount", this.account);
        this.$store.commit("businessaccount/setBusinessId", this.business_id);
        this.$store.commit(
          "businessaccount/setAccountCategory",
          this.accountCategory
        );
        this.$emit("next");
      }
    },
  },
};
</script>
<style scoped>
.gruop {
  margin-top: 16px;
}
.gruop p {
  text-align: right;
}
p.error {
  color: red;
  margin-right: 25px;
}
.account-type {
  background: #ddd;
  border-radius: 50px;
  height: 43px;
  font-family: "vazir";
}
</style>
